import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/servies/axios'
import api from '@/servies/api'
import _ from 'lodash'
import { stat } from 'fs'
import { mainList, settingList } from '@/utils/menu.js'
import { timeout } from 'q';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mainList:[],
    settingList:[],
    menuList: [],
    userInfo:{}
  },
  mutations: {
    setMenu(state, data) {
      state.menuList = data.menuList
      state.mainList = data.mainList
      state.settingList = data.settingList
    },
    setUser(state,data){
      state.userInfo = data
    }
  },
  actions: {
    getMenu({ commit, state }) {
      return new Promise((resolve, reject) => {
          return axios
            .get(api.menuList)
            .then(res => {
              if (res.data.code === 0) {
                console.log('获取菜单成功', res.data.result)
                let main = _.intersectionBy(mainList,res.data.result,'id').map((item,index) =>{
                  let main_children = _.intersectionBy(res.data.result,mainList,'id')[index].children
                  item.children =  _.intersectionBy(item.children,main_children,'id')

                  item.children.map((item2,index2)=> {
                    item2.children = main_children[index2].children
                    return item2
                  })
                return  item
                })
                let setting = _.intersectionBy(settingList,res.data.result,'id').map((item,index) =>{
                  let children = _.intersectionBy(res.data.result,settingList,'id')[index].children
                    item.children =  _.intersectionBy(item.children,children,'id')
                    item.children.map((item2,index2)=> {
                      item2.children = children[index2].children
                      return item2
                    })
                  return  item
              })
                commit('setMenu', {menuList:res.data.result,mainList:main,settingList:setting})
                resolve(res.data.result)
              } else {
                reject(res.data.message)
              }
            })
            .catch(error => {
              reject(error)
            })
      })
    },
    getUser({ commit, state }) {
      return new Promise((resolve, reject) => {
          return axios
            .get(api.userDetail)
            .then(res => {
              if (res.data.code === 0) {
                console.log('获取用户资料成功', res.data.result)
                commit('setUser', res.data.result)
                resolve(res.data.result)
              } else {
                reject(res.data.message)
              }
            })
            .catch(error => {
              reject(error)
            })
      })
    },
  }
})
